import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

import GrayButton from "~/components/traffic-tickets/steps/GrayButton"

import { CARD_TYPE_IMAGE_MAP, getCardTypeImage, MONTH_NAMES_MAP } from "~/utilities/constants"
import STYLE_CONSTANTS from "~/style/constants"

const Container = styled.div`
  display: flex;
  flex-direction: column;
`

const CardContainer = styled.div`
  font-family: ${(props) => props.theme.fonts.avenirNextRegular};
  font-size: 0.9rem;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  color: ${STYLE_CONSTANTS.colors.text.pronouncedGray};
  ${(props) => props.theme.media.mobile`
    align-items: flex-start;
    flex-direction: column;
  `}
`

const CardInfo = styled.div`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
`

const DetailsColumn = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
`

const CardImgContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;
`

const CardImg = styled.img`
  width: 72px;
  height: 45px;
  margin-right: 10px;
  border-radius: 4px;
`

const CardTypeImage = ({ cardType }) => {
  if (!cardType || !cardType.length) return null
  if (!CARD_TYPE_IMAGE_MAP[cardType]) return cardType
  return (
    <CardImgContainer>
      <CardImg src={CARD_TYPE_IMAGE_MAP[cardType]} alt={cardType} />
    </CardImgContainer>
  )
}

const Last4 = ({ last4 }) => {
  if (!last4 || !last4.length) return null
  return <div>{`Ending in ${last4}`}</div>
}

const Expires = ({ expirationMonth, expirationYear }) => {
  if (
    expirationMonth === null ||
    expirationMonth === undefined ||
    expirationYear === null ||
    expirationYear === undefined
  )
    return null
  return (
    <div>{`Expires ${MONTH_NAMES_MAP[expirationMonth]} ${expirationYear}`}</div>
  )
}

const ButtonHolder = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
  padding: 10px;
  ${(props) => props.theme.media.mobile`
    padding-left: 0;
  `}
`

const PaymentMethod = ({
  paymentType, // either "PayPal" or "Card"
  email, // only for paypal
  cardType,
  last4,
  expirationMonth,
  expirationYear,
  addHandler,
}) => {
  switch (paymentType) {
    case "Card": {
      return (
        <Container>
          <CardContainer>
            <CardInfo>
              <CardTypeImage cardType={cardType.charAt(0).toUpperCase() + cardType.slice(1).toLowerCase()} />
              <DetailsColumn>
                <Last4 last4={last4} />
                <Expires
                  expirationMonth={expirationMonth}
                  expirationYear={expirationYear}
                />
              </DetailsColumn>
            </CardInfo>
            <ButtonHolder>
              <GrayButton onClick={addHandler}>Add a new card</GrayButton>
            </ButtonHolder>
          </CardContainer>
        </Container>
      )
    }
    case "PayPal": {
      return (
        <Container>
          <CardContainer>
            <CardTypeImage cardType="PayPal" />
            <DetailsColumn>{email}</DetailsColumn>
            <GrayButton onClick={addHandler}>Add a new card</GrayButton>
          </CardContainer>
        </Container>
      )
    }
    default:
      return null
  }
}

PaymentMethod.defaultProps = {
  isDefault: false,
  cardType: null,
  last4: null,
  expirationMonth: null,
  expirationYear: null,
}

PaymentMethod.propTypes = {
  isDefault: PropTypes.bool,
  cardType: PropTypes.string,
  last4: PropTypes.string,
  expirationMonth: PropTypes.number,
  expirationYear: PropTypes.number,
}

export default PaymentMethod
